import React from 'react';
// import './Breadcrumbs.css';

function Breadcrumbs() {
    return (
        <nav className="breadcrumbs">
            <a href="/">Home</a>
            <span> &gt; </span>
            <a href="https://www.ontario.ca/page/education-and-training">Education and training</a>
            <span> &gt; </span>
            <a href="https://www.ontario.ca/page/go-college-or-university-ontario">Postsecondary education</a>
            <span> &gt; </span>
            <a href="/">How to apply?</a>
        </nav>
    );
}

export default Breadcrumbs;